<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <div class="title-page-text">
                {{ $t('v2.payment') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <template v-if="!$isEmpty(order.payment_log) && !(formattedTimeLeft === 'EXPIRED' || order.is_paid)">
            <div class="col-square mb-4">
              <div class="content-square">
                <img :src="order.payment_log.qr_image" alt="Qris" class="image-responsive">
              </div>
            </div>
            <v-btn :href="order.payment_log.qr_image" download="QRIS.png" block color="primary" height="40" class="ol-elevation-1 br-5 font-16 font-weight-700 text-none mb-2 letter-spacing-normal">
              <v-icon left>
                mdi-download
              </v-icon>
              {{ $t('v2.download_qris') }}
            </v-btn>
            <v-btn block color="olbrand" outlined height="40" class="mb-4 br-5 font-16 font-weight-700 text-none letter-spacing-normal letter-spacing-normal" @click="(dialog.payment_guide = true)">
              {{ $t('v2.payment_guide') }}
            </v-btn>
          </template>
          <div v-if="!order.is_paid" class="qris-countdown mb-4">
            <div class="qris-countdown-icon">
              <img src="@/assets/images/v2/img/icon_warning.png" alt="Warning">
            </div>
            <div class="qris-countdown-content">
              <template v-if="formattedTimeLeft !== '00:00' && formattedTimeLeft !== 'EXPIRED'">
                <div class="qris-countdown-title" v-html="$t('v2.immediately_pay_for_order_in', { time: formattedTimeLeft })" />
              </template>
              <div v-else class="qris-countdown-title four-line" v-html="$t('v2.your_payment_time_has_expired')" />
            </div>
          </div>
          <div class="pa-4 ol-elevation-2 br-8 mb-4">
            <div class="flex-image">
              <div v-if="!$isEmpty(order.logo)" class="flex-image-avatar mr-4">
                <img :src="order.logo.original" :alt="order.store_name" class="image-80">
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-18 font-weight-700 mb-1">
                  {{ order.store_name }}
                </div>
                <div class="flex-image-content-text font-14 font-weight-400 mb-1">
                  <span v-mask-money="order.total_amount" />
                </div>
                <div class="flex-image-content-text">
                  <div :class="['status-order', { 'status-pending': order.status_inquiry === 1, 'status-confirm': order.status_inquiry === 2, 'status-ready': order.status_inquiry === 3 || order.status_inquiry === 4 , 'status-done': order.status_inquiry === 5, 'status-failed': order.status_inquiry === 6 || order.status_inquiry === 7 }]">
                    {{ order.status_desc }}
                  </div>
                </div>
              </div>
              <div v-if="order.status_inquiry !== 1 && order.status_inquiry !== 2 && order.status_inquiry !== 5" class="ml-4 align-self-center">
                <v-btn width="24" height="24" icon color="#1FAD1F" :href="'https://wa.me/' + order.store_setting_whatsapp">
                  <v-icon>
                    mdi-whatsapp
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-if="order.notes" class="mt-4">
              <div class="text-order-notes">
                {{ order.notes }}
              </div>
            </div>
          </div>
          <div class="pa-4 ol-elevation-2 br-8">
            <div>
              <div class="d-flex align-center">
                <div>
                  <div class="font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.order_number') }}
                  </div>
                  <div class="font-18 font-weight-700">
                    {{ order.order_no }}
                  </div>
                </div>
                <v-spacer />
                <div v-if="order.remark === 'OL-DINE-IN'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_table" :alt="$t('table')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('table') }} {{ order.table_no }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'RESERVATION'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_side_reservation" :alt="order.remark">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ order.remark }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-line my-4" />
            <div>
              <div class="d-flex align-center">
                <div class="font-14 font-weight-400">
                  {{ $t('v2.date') }}
                </div>
                <v-spacer />
                <div class="font-14 font-weigth-600">
                  {{ order.forder_date }}, {{ order.forder_time }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="order.remark === 'RESERVATION'" class="mt-4">
            <div class="pa-4 ol-elevation-2 br-8">
              <div>
                <div>
                  <div class="d-flex justify-space-between">
                    <div class="">
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.reservation_date') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ $formatDate(order.reserve_date, true) }}
                      </div>
                    </div>
                    <div>
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.time') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ order.freserve_time }}
                      </div>
                    </div>
                    <div>
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.number_of_tables') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ order.total_guest }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="div-line my-4" />
                <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 font-16" @click="updateReservation()">
                  {{ $t('v2.change') }}
                </v-btn> -->
              </div>
            </div>
          </div>

          <div class="list-item-checkout mt-4">
            <template v-for="(item, idx) in order.items">
              <div v-if="item.note !== 'REDEEMED'" :key="idx" class="container-item-checkout">
                <div class="item-checkout">
                  <div class="item-checkout-qty font-16 font-weight-600 ol-brand mr-2">
                    {{ item.qty }}x
                  </div>
                  <div class="item-checkout-content">
                    <div class="item-checkout-name font-16 font-weight-400 mb-1">
                      {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                    </div>
                    <div class="item-checkout-text font-14 font-weight-700 mb-3">
                      <span v-mask-money="item.amount" />
                    </div>
                    <div v-if="textAddons(item) !== ''" class="item-checkout-text ol-accent font-12 font-weight-400 mb-1">
                      {{ textAddons(item) }}
                    </div>
                    <div v-if="item.note !== ''" class="item-checkout-text">
                      <div class="d-flex align-center">
                        <div class="mr-1">
                          <v-icon size="18" color="#767676" style="transform: rotate(180deg) scale(-1, 1);">
                            mdi-note-outline
                          </v-icon>
                        </div>
                        <div class="font-12 font-weight 400 ol-grey-content">
                          {{ notTakeaway(item.note) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isTakeaway(item.note)" class="align-self-start ml-2">
                    <div class="font-12 font-weight-600 px-2 py-1 br-5 ol-black bg-grey">
                      {{ $t('v2.takeaway') }}
                    </div>
                  </div>
                </div>
                <div class="list-line" />
              </div>
            </template>
          </div>

          <div class="line-low my-4" />
          <div class="list-price">
            <div class="title-list-price">
              {{ $t('v2.price') }}
            </div>
            <div class="list-component-price">
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.subtotal') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.order_amount" class="list-item-nominal-price" />
              </div>
              <div v-if="order.discount_amount > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.discount') }}
                  <span v-if="order.discount_voucher_code && order.discount_voucher_code !== ''">
                    ({{ order.discount_voucher_code }})
                  </span>
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  -<span v-mask-money-only="order.discount_amount" />
                </div>
              </div>
              <div v-if="!$isEmpty(order.points) && order.points.type === 'D' && Number(order.points.redeemed_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.voucher_point') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  -
                  <span v-mask-money-only="order.points.redeemed_amount" />
                </div>
              </div>
              <div v-if="Number(order.service_charge_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.service_charge') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.service_charge_amount" class="list-item-nominal-price" />
              </div>
              <div v-if="Number(order.tax_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $store.state.selected_outlet.tax_name ? $store.state.selected_outlet.tax_name : $t('v2.tax') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.tax_amount" class="list-item-nominal-price" />
              </div>
              <div v-if="Number(order.rounded_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.rounded_amount" class="list-item-nominal-price" />
              </div>
              <div v-else-if="Number(order.rounded_amount) < 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.rounded_amount" class="list-item-nominal-price ol-accent" />
              </div>
            </div>
            <div class="line-dot my-4" />
            <div class="total-price">
              <div class="total-price-title">
                {{ $t('v2.total') }}
              </div>
              <v-spacer />
              <div v-mask-money="order.total_amount" class="total-nominal-price" />
            </div>
            <div v-if="order.payment_mode_id === 10" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ $t('v2.pay_at_the_cashier') }}
              </div>
            </div>
            <div v-else-if="!$isEmpty(order.payment_log) && order.payment_log.payment_source === 'VIRTUAL-ACCOUNT'" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                BANK {{ order.payment_log.va_bank_code }}
              </div>
            </div>
            <div v-else-if="!$isEmpty(order.payment_log)" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ order.payment_log.payment_type }}
              </div>
            </div>
            <div v-else class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ order.payment_mode_name }}
              </div>
            </div>
            <template v-if="!$isEmpty(order.points) && order.points.earned_points > 0">
              <div class="line-dot my-6" />
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.point_earned') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  +{{ Number(order.points.earned_points) }} pts
                </div>
              </div>
            </template>
          </div>
          <div class="mt-4">
            <template v-for="(item, idx) in order.items">
              <div v-if="item.note === 'REDEEMED'" :key="idx" class="mb-2">
                <div class="flex-image pa-4 bg-accent-soft br-8">
                  <div class="mr-2">
                    <img src="@/assets/images/v2/img/icon_point.png" alt="Voucher" class="image-22">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-14 font-weight-600 ol-black two-line">
                      {{ Number(item.qty) }}x {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                    </div>
                    <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                      {{ $t('v2.from_point_exchange') }}
                    </div>
                  </div>
                  <div class="font-12 font-weight-400 ol-black ml-2">
                    {{ !$isEmpty(order.points) && order.points.redeemed_amount && Number(order.points.redeemed_amount) ? '-' + Number(order.points.redeemed_points) + ' pts' : '' }}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="mt-10">
            <v-btn v-if="order.status_inquiry === 5 || order.status_inquiry === 6 || order.status_inquiry === 7" block color="primary" height="40" class="br-5 ol-red font-weight-700 text-none white--text ol-elevation-1 letter-spacing-normal mb-2" @click="reOrder()">
              {{ $t('v2.reorder') }}
            </v-btn>
            <v-btn v-if="formattedTimeLeft !== 'EXPIRED' && formattedTimeLeft !== '00:00' && order.status === 'P' && !$isEmpty(order.payment_log) && order.payment_log.global_status === 'P'" block color="olbrand" height="40" class="br-5 white--text font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="refreshPage">
              {{ $t('v2.update_payment_status') }}
            </v-btn>
            <v-btn v-if="order.status === 'P' && order.is_paid === 0 && Number(order.total_amount) !== 0 && order.payment_mode_id !== 10" block color="white" height="40" class="br-5 ol-black font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="changePayment()">
              {{ $t('v2.change_payment_method') }}
            </v-btn>
            <v-btn block color="white" height="40" class="br-5 ol-black font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="backToMenu">
              {{ $t('v2.back_to_menu') }}
            </v-btn>
            <template v-if="order.status === 'P' && order.is_paid === 0">
              <v-btn block color="white" height="40" class="br-5 ol-red font-weight-700 text-none ol-elevation-1 letter-spacing-normal" @click="confirmCancel">
                {{ $t('v2.cancel_order') }}
              </v-btn>
            </template>
          </div>
          <v-bottom-sheet v-model="dialog.payment_guide" content-class="dialog-icon">
            <div class="position-relative">
              <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.payment_guide = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
            <v-sheet class="sheet-border">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                    <div class="mt-2 font-18 font-weight-700 mb-4">
                      {{ $t('v2.how_to_pay_with_qris') }}
                    </div>
                    <ol class="list-qris-guide">
                      <li>
                        {{ $t('v2.press_the_download_qris_button') }}
                      </li>
                      <li>
                        {{ $t('v2.oppen_an_eWallet_ebanking') }}
                      </li>
                      <li>
                        {{ $t('v2.look_for_the_qris_scan_option') }}
                      </li>
                      <li>
                        {{ $t('v2.after_scanning_the_total_transaction_price_will_appear') }}
                      </li>
                      <li>
                        {{ $t('v2.confirm_and_pay') }}
                      </li>
                      <li>
                        {{ $t('v2.you_have_successfully_paid') }}
                      </li>
                    </ol>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
          </v-bottom-sheet>
          <v-dialog v-model="dialog.confirm_cancel" persistent max-width="350">
            <v-card class="br-10">
              <div class="pa-4">
                <div class="text-center font-18 font-weight-700 mb-4">
                  {{ $t('v2.are_you_sure_want_to_cancel_the_order') }}
                </div>
                <div class="card-action-button">
                  <div class="card-action-item-button">
                    <v-btn block color="white" height="40" class="text-none font-weight-700 ol-black letter-spacing-normal ol-elevation-1 br-5" @click="dialog.confirm_cancel = false">
                      {{ $t('v2.cancel2') }}
                    </v-btn>
                  </div>
                  <div class="card-action-item-button">
                    <v-btn block color="white" height="40" class="text-none font-weight-700 ol-red letter-spacing-normal ol-elevation-1 br-5" @click="cancelOrder(order.id)">
                      {{ $t('v2.yes_cancel') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-dialog>
          <alert v-model="dialog_alert.show" :message="dialog_alert.message" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  getDataDetail as getDataDetailOrder,
  cancelOrder as cancelDataOrder
} from '@/api/order'
import {
  hitPoint as hitDataPoint
} from '@/api/point'
import {
  hitDiscount as hitDataDiscount
} from '@/api/discount'
import {
  checkMaterial as checkStockMaterial
} from '@/api/product'
import Alert from '@/components/v2/Alert'
import { checkInventory, prepareCartItem, validateStockMaterial } from '@/utils/order'
export default {
  components: {
    Alert
  },
  data() {
    return {
      dialog_alert: {
        show: false,
        message: ''
      },
      dialog: {
        payment_guide: false,
        confirm_cancel: false
      },
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      icon_side_reservation: require('@/assets/images/v2/img/icon-side-reservation.png'),
      order: {},
      expired_time: 0,
      timerOrderInterval: null,
      cart: {},
      temp_cart: {},
      materials: []
    }
  },
  computed: {
    formattedTimeLeft() {
      let days = Math.floor(this.expired_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.expired_time % (1000 * 60)) / 1000)
      let result
      if (this.expired_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ' : ' : hours + ' : '
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  beforeDestroy() {
    clearInterval(this.timerOrderInterval)
  },
  sockets: {
    connect: function() {
      console.log('socket connected')
    },
    admin_pusher_status(data) {
      const success = 'netzme_' + this.order.id + '_status = success'
      const error = 'netzme_' + this.order.id + '_status = error'
      if (data.title === success) {
        this.$router.push({ name: '_order', params: { id: this.order.id }}).catch(() => {})
      } else if (data.title === error) {
        this.$router.push({ name: '_order', params: { id: this.order.id }}).catch(() => {})
      }
    },
    customEmit: function(data) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    }
  },
  created() {
    this.getOrder()
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
  },
  methods: {
    notTakeaway(note) {
      const arrNote = note.split(',')
      if (arrNote[0] === 'TAKE AWAY') {
        arrNote.splice(0, 1)
      }
      return arrNote.toString()
    },
    isTakeaway(note) {
      const arrNote = note.split(',')
      if (arrNote[0] === 'TAKE AWAY') {
        return true
      }
      return false
    },
    refreshPage() {
      location.reload()
    },
    backToMenu() {
      this.$router.push({ name: '_menu' }).catch(() => {})
    },
    async cancelOrder(id) {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        await cancelDataOrder(id, params)
        this.dialog_alert.show = true
        this.dialog_alert.message = this.$t('v2.order_successfully_cancelled')
        this.dialog.confirm_cancel = false
        setTimeout(() => {
          this.$router.push({ name: '_menu' }).catch(() => {})
        }, 3000)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    confirmCancel() {
      this.dialog.confirm_cancel = true
    },
    async getOrder() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.$route.params.id, params)
        this.order = data.data
        if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.expired_at) {
          this.getExpiryTime(this.order.payment_log.expired_at)
        }
        if (this.order.is_paid) {
          clearInterval(this.timerOrderInterval)
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    textAddons(item) {
      if (item.product_combo_id) {
        const arr = []
        for (let i = 0; i < item.item_product_combo.length; i++) {
          arr.push(item.item_product_combo[i].item_name)
        }
        return arr.join(', ')
      } else {
        if (typeof item.addon !== 'undefined' && item.addon.length !== 0) {
          const names = item.addon.map(function(item) {
            return item['name']
          })
          return names.join(', ')
        } else {
          return ''
        }
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerOrderInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.expired_time = countDownDate - now
        if (_this.expired_time < 0) {
          clearInterval(_this.timerOrderInterval)
        }
      }, 1000)
    },
    async checkStockMaterialObj(objId) {
      try {
        const { data } = await checkStockMaterial(objId)
        this.materials = data.data.materials
      } catch (e) {
        this.materials = []
        Object.assign(this.$store.state, {
          show_error: true,
          error_message: e.string,
          error_type: e.statusCode
        })
      }
    },
    async reOrder() {
      const cart = []
      let reorder = true
      for (const item of this.order.items) {
        if (item.product_has_material && !item.track_inventory) {
          await this.checkStockMaterialObj({
            product_id: item.product_id || undefined,
            product_variant_id: item.product_variant_id || undefined
          })
        }
        if (await checkInventory(item, this.materials)) {
          reorder = false
          break
        }
        if (item.note !== 'REDEEMED') {
          cart.push(prepareCartItem(item, this.materials))
        }
      }

      reorder = reorder && await validateStockMaterial(cart)

      if (reorder) {
        this.cart.item = cart
        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_checkout' }).catch(() => {})
      }
    },
    async changePayment() {
      const cart = []
      let reorder = true
      for (const item of this.order.items) {
        if (item.product_has_material && !item.track_inventory) {
          await this.checkStockMaterialObj({
            product_id: item.product_id || undefined,
            product_variant_id: item.product_variant_id || undefined
          })
        }
        if (await checkInventory(item, this.materials)) {
          reorder = false
          break
        }
        if (item.note !== 'REDEEMED') {
          cart.push(prepareCartItem(item, this.materials))
        }
      }
      this.cart.item = cart

      reorder = reorder && await validateStockMaterial(cart)

      if (this.order.remark === 'DELIVERY') {
        const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
        if (DETAIL_LOCATION) {
          const detail_location = JSON.parse(DETAIL_LOCATION)
          this.locations = detail_location
        }
        const arrAdd = this.order.shipping_address.split('--')
        this.$set(this.locations, 'name', arrAdd[0].trim())
        this.$set(this.locations, 'shipping_address', arrAdd[1].trim())
        this.$set(this.locations, 'driver_note', '')
        this.$set(this.locations, 'shipping_lat', this.order.shipping_lat)
        this.$set(this.locations, 'shipping_lon', this.order.shipping_lon)
        this.$set(this.locations, 'shipping_radius', this.order.shipping_radius)
        this.$store.dispatch('saveLocationV2', this.locations)

        if (Number(this.order.shipping_delivery_type) === 1) {
          this.shipping.shipping_cost = Number(this.order.shipping_cost)
          this.shipping.shipping_courier_id = this.order.shipping_courier_id
          this.shipping.shipping_courier_name = this.$t('v2.restaurant_courier')
          this.shipping.shipping_delivery_type = 1
          this.shipping.shipping_logo = require('@/assets/images/v2/img/icon_restaurant_courier.png')
          this.shipping.shipping_time = this.order.shipping_time
        }
        this.$store.dispatch('saveShippingV2', this.shipping)
      }

      if (reorder) {
        if (!this.$isEmpty(this.order.points) && this.order.points.redeem_id) {
          await this.hitPoint()
        }
        if (this.order.discount_voucher_id) {
          await this.hitVoucher(this.order.discount_voucher_id)
        }
        this.cart.total_pay = Number(this.order.total_amount)
        this.cart.previousOrderId = this.order.id

        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_payment' }).catch(() => {})
      }
    },
    async hitPoint() {
      this.cart.redeem_id = this.order.points.redeem_id
      this.cart.remark = this.order.remark
      const data_hit = { ...this.cart }
      try {
        const { data } = await hitDataPoint(data_hit)
        this.cart.requestId = data.requestId
        this.cart.redeemId = this.cart.redeem_id
        this.cart.point_detail = data.point_detail
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
      delete this.cart.redeem_id
      delete this.cart.remark
    },
    async hitVoucher(id) {
      const data_hit = { ...this.cart }
      data_hit.discount_id = id
      data_hit.remark = this.$store.state.selected_type
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      try {
        const { data } = await hitDataDiscount(data_hit)
        this.cart.discount_voucher_id = id
        this.$set(this.cart, 'discount_detail', data.data)
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
